import { HomePage } from '@/features/home/pages/HomePage';
import { DestinationsPage } from '@/features/destinations/pages/DestinationsPage';
import { guidesPublicRoutes } from '@/features/guides/routes';
import { bookingRoutes } from '@/features/guides/routes';
import { userRoutes } from '@/features/users/routes';
import { aboutRoutes } from '@/features/about/routes';
import { howItWorksRoutes } from '@/features/how-it-works/routes';
import { blogRoutes } from '@/features/blogs/routes';
import { legalRoutes } from '@/features/legal/routes';
import { guideIdentityPublicRoutes } from '@/features/guide-identity/routes';

export const publicRoutes = [
  { index: true, element: <HomePage /> },
  ...guideIdentityPublicRoutes,
  ...guidesPublicRoutes,
  ...bookingRoutes,
  ...userRoutes,
  ...aboutRoutes,
  ...howItWorksRoutes,
  ...blogRoutes,
  ...legalRoutes,
  { path: 'destinations', element: <DestinationsPage /> },
];
